import { render, staticRenderFns } from "./RegraMapeamento.vue?vue&type=template&id=60702c8c&scoped=true"
import script from "./RegraMapeamento.vue?vue&type=script&lang=js"
export * from "./RegraMapeamento.vue?vue&type=script&lang=js"
import style0 from "./RegraMapeamento.vue?vue&type=style&index=0&id=60702c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60702c8c",
  null
  
)

export default component.exports